/* ==========================================================================
   AJ FITS — Shop interactions
   Quick add, quick view, hero slideshow, testimonial rotator, stat counters.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function toast(msg, opts) {
    if (window.AJ && window.AJ.toast) return window.AJ.toast(msg, opts);
  }

  /* Falls back to "no cap" if aj-stock.js is missing; Shopify still guards. */
  var stockStub = {
    parse: function () { return Infinity; },
    inCart: function () { return 0; },
    remaining: function () { return Infinity; },
    allow: function () { return true; },
    warn: function () {},
    refresh: function () {},
    friendlyError: function (err) { return (err && err.message) || 'Could not add to cart'; }
  };

  function stockApi() {
    return (window.AJ && window.AJ.stock) || stockStub;
  }

  /* =====================================================================
     Quick add to cart
     ===================================================================== */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-aj-quick-add]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      // One tap = one unit, so the only question is whether one more fits.
      var stock = stockApi();
      if (!stock.allow(variantId, btn.dataset.stockMax, 1)) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      var payload = { items: [{ id: Number(variantId), quantity: 1 }] };

      var request = window.AJ && window.AJ.cart
        ? window.AJ.cart.add(payload)
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (r) { return r.json(); });

      request
        .then(function () {
          if (window.AJ && window.AJ.cart) return window.AJ.cart.refreshBadge();
        })
        .then(function () {
          toast((btn.dataset.productTitle || 'Item') + ' added to cart', {
            action: { href: '/cart', label: 'View cart' }
          });
          refreshCartDrawer();
        })
        .catch(function (err) {
          toast(stock.friendlyError(err), { type: 'error' });
          stock.refresh();
        })
        .finally(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  }

  /* Ask Dawn's cart drawer to re-render after an AJAX add */
  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections, sections_html: sections });
        } else if (sections['cart-drawer']) {
          var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = parsed.querySelector('cart-drawer');
          if (fresh) drawer.innerHTML = fresh.innerHTML;
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
        }
      })
      .catch(function () { /* badge already updated; drawer refresh is a bonus */ });
  }

  /* =====================================================================
     Quick view
     ===================================================================== */
  function initQuickView() {
    var modal = null;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-aj-quickview]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      modal = ensureModal();
      var body = $('[data-aj-quickview-body]', modal);
      body.innerHTML = '<div class="aj-quickview__loading"><span class="aj-spinner"></span></div>';

      if (window.AJ && window.AJ.openModal) window.AJ.openModal('AjQuickView');

      var url = btn.dataset.productUrl;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=aj-quick-view', {
        headers: { Accept: 'text/html' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Not available');
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');

          // Take the whole section wrapper, not just the inner content — the
          // <link> tags for the quick-view CSS sit outside it, and collection
          // pages do not load those stylesheets otherwise.
          var section = parsed.querySelector('.shopify-section') ||
                        parsed.querySelector('[data-aj-quickview-content]');
          if (!section) throw new Error('Empty quick view');

          body.innerHTML = section.innerHTML;

          // <link> inserted via innerHTML is inert in some browsers; re-create
          // each one so the stylesheet actually loads.
          Array.prototype.forEach.call(body.querySelectorAll('link[rel="stylesheet"]'), function (old) {
            if (document.querySelector('link[data-aj-qv-css="' + old.href + '"]')) {
              old.remove();
              return;
            }
            var fresh = document.createElement('link');
            fresh.rel = 'stylesheet';
            fresh.href = old.href;
            fresh.setAttribute('data-aj-qv-css', old.href);
            document.head.appendChild(fresh);
            old.remove();
          });

          if (window.AJ && window.AJ.refresh) window.AJ.refresh(body);
          initQuickViewForm(body);
        })
        .catch(function () {
          // Falling back to the product page is better than showing an error
          window.location.href = url;
        });
    });

    function ensureModal() {
      var existing = document.getElementById('AjQuickView');
      if (existing) return existing;

      var el = document.createElement('div');
      el.className = 'aj-modal aj-quickview';
      el.id = 'AjQuickView';
      el.setAttribute('data-aj-modal', '');
      el.hidden = true;
      el.innerHTML =
        '<div class="aj-modal__overlay" data-aj-modal-close></div>' +
        '<div class="aj-modal__panel aj-modal__panel--wide">' +
        '<button class="aj-modal__close aj-quickview__close" type="button" data-aj-modal-close aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" style="pointer-events:none"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
        '</button>' +
        '<div class="aj-modal__body" data-aj-quickview-body></div>' +
        '</div>';
      document.body.appendChild(el);

      // Bind close directly rather than relying on the shared delegate — this
      // node is created after aj-app.js has already scanned the document.
      Array.prototype.forEach.call(el.querySelectorAll('[data-aj-modal-close]'), function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (window.AJ && window.AJ.closeModal) window.AJ.closeModal(el);
          else { el.classList.remove('is-open'); el.hidden = true; document.body.style.overflow = ''; }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !el.hidden && window.AJ && window.AJ.closeModal) window.AJ.closeModal(el);
      });

      if (window.AJ && window.AJ.refresh) window.AJ.refresh(el);
      return el;
    }
  }

  /* Wire variant selection inside the quick view */
  function initQuickViewForm(root) {
    var form = $('[data-aj-qv-form]', root);
    if (!form) return;

    var data = $('[data-aj-qv-variants]', root);
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var priceEl = $('[data-aj-qv-price]', root);
    var compareEl = $('[data-aj-qv-compare]', root);
    var idInput = $('[data-aj-qv-id]', root);
    var submit = $('[data-aj-qv-submit]', root);
    var current = null;

    function selected() {
      return $$('[data-aj-qv-option]', root)
        .filter(function (i) { return i.checked; })
        .map(function (i) { return i.value; });
    }

    function update() {
      var chosen = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      current = match || null;

      if (!match) {
        submit.disabled = true;
        submit.textContent = 'Unavailable';
        return;
      }

      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (compareEl) {
        compareEl.textContent = match.compare_at_price || '';
        compareEl.hidden = !match.compare_at_price;
      }
      submit.disabled = !match.available;
      submit.textContent = match.available ? 'Add to cart' : 'Sold out';
    }

    $$('[data-aj-qv-option]', root).forEach(function (input) {
      input.addEventListener('change', update);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var stock = stockApi();
      if (current && !stock.allow(current.id, current.stock_max, 1)) return;

      submit.disabled = true;
      submit.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            // A 422 here is nearly always an oversell — surface it, don't
            // fall through to the success toast.
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            return data;
          });
        })
        .then(function () {
          if (window.AJ && window.AJ.cart) window.AJ.cart.refreshBadge();
          toast('Added to cart', { action: { href: '/cart', label: 'View cart' } });
          if (window.AJ && window.AJ.closeModal) window.AJ.closeModal('AjQuickView');
          refreshCartDrawer();
        })
        .catch(function (err) {
          toast(stock.friendlyError(err), { type: 'error' });
          stock.refresh();
        })
        .finally(function () {
          submit.disabled = false;
          submit.classList.remove('is-loading');
        });
    });

    update();
  }

  /* =====================================================================
     Hero slideshow
     ===================================================================== */
  function initHero(root) {
    $$('[data-aj-hero]', root).forEach(function (hero) {
      if (hero.dataset.ajHeroReady) return;
      hero.dataset.ajHeroReady = '1';

      var texts = $$('[data-aj-hero-text]', hero);
      var medias = $$('[data-aj-hero-media]', hero);
      var dots = $$('[data-aj-hero-dot]', hero);
      var total = Math.max(texts.length, medias.length);
      if (total < 2) return;

      var index = 0;
      var timer = null;
      var interval = (parseInt(hero.dataset.interval, 10) || 6) * 1000;
      var autoplay = hero.dataset.autoplay === 'true' && !reduceMotion;

      hero.style.setProperty('--aj-hero-interval', interval + 'ms');

      function go(next) {
        index = (next + total) % total;

        texts.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
        medias.forEach(function (el, i) {
          el.classList.toggle('is-active', i === index);
          if (i === index && typeof hydrate === 'function') hydrate(el);
        });
        dots.forEach(function (d, i) {
          var on = i === index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
          d.classList.remove('is-timing');
        });

        if (autoplay && dots[index]) {
          // Restart the progress fill for the newly active dot
          void dots[index].offsetWidth;
          dots[index].classList.add('is-timing');
        }
      }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(function () { go(index + 1); }, interval);
        if (dots[index]) {
          void dots[index].offsetWidth;
          dots[index].classList.add('is-timing');
        }
      }

      // Hold the first rotation until the page has loaded and visually
      // settled. Rotating during first paint tanks Speed Index for no
      // benefit — nobody has read the first slide yet either.
      function startWhenSettled() {
        if (!autoplay) return;
        var delay = 1200;
        if (document.readyState === 'complete') {
          setTimeout(start, delay);
        } else {
          window.addEventListener('load', function () { setTimeout(start, delay); }, { once: true });
        }
      }

      function stop() { if (timer) clearInterval(timer); timer = null; }

      /* Slides 2+ ship without a real src so they cannot compete with the LCP
         image for bandwidth. Swap the real sources in once the page is done,
         or immediately if the shopper reaches that slide first. */
      function hydrate(slide) {
        if (!slide || slide.dataset.ajHydrated) return;
        slide.dataset.ajHydrated = '1';
        $$('source[data-aj-srcset]', slide).forEach(function (src) {
          src.srcset = src.dataset.ajSrcset;
          src.removeAttribute('data-aj-srcset');
        });
        $$('img[data-aj-src]', slide).forEach(function (img) {
          if (img.dataset.ajSrcset) img.srcset = img.dataset.ajSrcset;
          img.src = img.dataset.ajSrc;
          img.removeAttribute('data-aj-src');
          img.removeAttribute('data-aj-srcset');
        });
      }

      function hydrateAll() { medias.forEach(hydrate); }

      if (document.readyState === 'complete') {
        setTimeout(hydrateAll, 400);
      } else {
        window.addEventListener('load', function () { setTimeout(hydrateAll, 400); }, { once: true });
      }

      var prev = $('[data-aj-hero-prev]', hero);
      var next = $('[data-aj-hero-next]', hero);
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { go(i); start(); });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      // Pause when the tab is hidden so timers do not stack up
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });

      // Touch swipe
      var startX = 0;
      hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) { go(dx < 0 ? index + 1 : index - 1); start(); }
      }, { passive: true });

      go(0);
      startWhenSettled();
    });
  }

  /* =====================================================================
     Testimonial rotator
     ===================================================================== */
  function initReviews(root) {
    $$('[data-aj-reviews]', root).forEach(function (wrap) {
      if (wrap.dataset.ajReviewsReady) return;
      wrap.dataset.ajReviewsReady = '1';

      var items = $$('[data-aj-review]', wrap);
      var dots = $$('[data-aj-review-dot]', wrap);
      if (items.length < 2) return;

      var i = 0;
      var timer = null;

      function go(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
        dots.forEach(function (d, idx) {
          var on = idx === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function start() {
        if (reduceMotion) return;
        stop();
        timer = setInterval(function () { go(i + 1); }, 7000);
      }
      function stop() { if (timer) clearInterval(timer); }

      dots.forEach(function (d, idx) {
        d.addEventListener('click', function () { go(idx); start(); });
      });
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);

      go(0);
      start();
    });
  }

  function initTestimonials(root) {
    $$('[data-aj-testi-quotes]', root).forEach(function (wrap) {
      if (wrap.dataset.ajTestiReady) return;
      wrap.dataset.ajTestiReady = '1';

      var section = wrap.closest('section') || document;
      var quotes = $$('[data-aj-testi-quote]', wrap);
      var dots = $$('[data-aj-testi-dot]', section);
      if (quotes.length < 2) return;

      var i = 0;
      var timer = null;

      function go(n) {
        i = (n + quotes.length) % quotes.length;
        quotes.forEach(function (q, idx) { q.classList.toggle('is-active', idx === i); });
        dots.forEach(function (d, idx) {
          var on = idx === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function start() {
        if (reduceMotion) return;
        stop();
        timer = setInterval(function () { go(i + 1); }, 6500);
      }
      function stop() { if (timer) clearInterval(timer); }

      dots.forEach(function (d, idx) {
        d.addEventListener('click', function () { go(idx); start(); });
      });

      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);

      go(0);
      start();
    });
  }

  /* =====================================================================
     Stat counters
     ===================================================================== */
  function initCounters(root) {
    var els = $$('[data-aj-count-to]', root);
    if (!els.length || reduceMotion || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countUp(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    var raw = el.dataset.countTo || el.textContent;
    // Keep any prefix/suffix ("50,000+", "₹2Cr") around the numeric part
    var match = String(raw).match(/([^\d]*)([\d,.]+)(.*)/);
    if (!match) return;

    var prefix = match[1];
    var target = parseFloat(match[2].replace(/,/g, ''));
    var suffix = match[3];
    if (isNaN(target)) return;

    var duration = 1400;
    var startTime = null;

    function frame(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      // easeOutExpo
      var eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      var value = Math.round(target * eased);
      el.textContent = prefix + value.toLocaleString('en-IN') + suffix;
      if (progress < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  /* =====================================================================
     Boot
     ===================================================================== */
  function boot(root) {
    root = root || document;
    initHero(root);
    initReviews(root);
    initTestimonials(root);
    initCounters(root);
  }

  function once() {
    initQuickAdd();
    initQuickView();
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', once, { once: true });
  } else {
    once();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
